import { render } from "./ManagerRates.vue?vue&type=template&id=f54188c4"
import script from "./ManagerRates.vue?vue&type=script&lang=js"
export * from "./ManagerRates.vue?vue&type=script&lang=js"

import "./ManagerRates.vue?vue&type=style&index=0&id=f54188c4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__